import React from "react";
import { Card, Col, Row, Statistic, theme } from "antd";
import { KeyOutlined, UnlockOutlined, UserOutlined } from "@ant-design/icons";
import { useKols } from "../hooks/useKols";
import { useSessions } from "../hooks/useSessions";
import { useOwnershipRequests } from "../hooks/useOwnership";

const Home: React.FC = () => {
  const {
    token: { colorBgContainer, colorBorderSecondary },
  } = theme.useToken();

  const { data: ownershipRequestsData, isLoading: isOwnershipRequestsLoading } =
    useOwnershipRequests({
      page: 1,
      limit: 10,
      status: "pending",
    });
  const { data: sessionsData, isLoading: isSessionsLoading } = useSessions();
  const { data: kolsData, isLoading: isKolsLoading } = useKols({
    page: 1,
    limit: 10,
  });

  return (
    <div className="relative">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          position: "sticky",
          top: 0,
          zIndex: 1,
          background: colorBgContainer,
          borderBottom: `1px solid ${colorBorderSecondary}`,
          marginBottom: "16px",
        }}
      >
        <h2>General</h2>
      </div>

      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Card variant="borderless">
            <Statistic
              title="Ownership Requests"
              loading={isOwnershipRequestsLoading}
              value={ownershipRequestsData?.totalDocs ?? 0}
              prefix={<KeyOutlined />}
            />
          </Card>
        </Col>
        <Col span={12}>
          <Card variant="borderless">
            <Statistic
              title="KOLs"
              loading={isKolsLoading}
              value={kolsData?.totalDocs ?? 0}
              prefix={<UserOutlined />}
            />
          </Card>
        </Col>
        <Col span={12}>
          <Card variant="borderless">
            <Statistic
              title="Sessions"
              loading={isSessionsLoading}
              value={sessionsData?.length ?? 0}
              prefix={<UnlockOutlined />}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Home;
